import type { SVGProps } from "react";
export function ToastIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-slot="icon"
      fill="none"
      height={20}
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 20 20"
      width={20}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 0c2.793 0 4.189 0 5.312.393a7 7 0 0 1 4.295 4.295C20 5.811 20 7.208 20 10s0 4.189-.393 5.312a7 7 0 0 1-4.295 4.295C14.189 20 12.792 20 10 20s-4.189 0-5.312-.393a7 7 0 0 1-4.295-4.295C0 14.189 0 12.792 0 10s0-4.189.393-5.312A7 7 0 0 1 4.688.393C5.811 0 7.208 0 10 0M5.834 12.5a1.667 1.667 0 1 0 0 3.334 1.667 1.667 0 0 0 0-3.334m4.166 0a1.667 1.667 0 1 0 0 3.334 1.667 1.667 0 0 0 0-3.334m4.167 0a1.667 1.667 0 1 0 0 3.334 1.667 1.667 0 0 0 0-3.334M5.834 8.333a1.667 1.667 0 1 0 0 3.335 1.667 1.667 0 0 0 0-3.335m4.166 0a1.667 1.667 0 1 0 0 3.334 1.667 1.667 0 0 0 0-3.334m4.167 0a1.667 1.667 0 1 0 0 3.334 1.667 1.667 0 0 0 0-3.334M5.834 4.167a1.667 1.667 0 1 0 0 3.333 1.667 1.667 0 0 0 0-3.333m4.166 0A1.667 1.667 0 1 0 10 7.5a1.667 1.667 0 0 0 0-3.333m4.167 0a1.667 1.667 0 1 0 0 3.333 1.667 1.667 0 0 0 0-3.333"
        fill="currentColor"
      />
    </svg>
  );
}
